import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class DeleteVideoApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/video/delete/',
      requesterInfo,
    })
  }

  public async deleteVideo(id: number): Promise<boolean> {
    this.props.url = `${this.props.url}${id}`
    return await this.deleteAsync<boolean>()
  }
}
